import React from 'react';
import SectionContainer from '../../../common/SectionContainer';
import FieldRow from '../../../common/FieldRow';
import { raiFinal as raiFn } from '../formulas';

const RAIFinalSection = ({ data, computed }) => {
  return (
    <SectionContainer title="RAI Final" subtitle="Determinación RAI al 31.12.2024">
      <div className="f22-subsection">
        <FieldRow label="Capital propio tributario simplificado al 31.12.2024" sign="(+)"
          value={raiFn.cptsPositivo(data)} computed />
        <FieldRow label="Retiros del ejercicio históricos al 31.12.2024" sign="(+)"
          value={raiFn.retirosHistoricos(data)} computed />
        <FieldRow label="Saldo registro REX positivo antes de imputación" sign="(-)"
          value={raiFn.saldoREXPositivo(data)} computed />
        <FieldRow label="Capital social aportado histórico al 31.12.2024" sign="(-)"
          value={raiFn.capitalSocial(data)} computed />
        <FieldRow label="Rentas afectas del ejercicio (RAI)" sign="(=)"
          value={computed.raiFinal?.rai} computed className="f22-field-total" />
      </div>
    </SectionContainer>
  );
};

export default RAIFinalSection;
